<template>
    <div class="pb-4 cmv-newscontent">
        <div
            class="container-fluid py-sm-1 py-0 my-3 cm-news-list"
            v-for="(item) in news.slice(
                (this.currentPage -1) * this.perPage,
                this.currentPage * this.perPage
            )"
            :key="item.id"
        >
            <div class="offset-1 col-10 offset-sm-2 col-sm-8 row cm-news-block">
                <div class="col-lg-5 col-12 p-0 d-flex align-items-start">
                    <img class="my-lg-3 my-4 cm-news-img" :src="item.newsimg">
                </div>
                <div class="col-lg-7 col-12 p-0 p-lg-3">
                    <p class="d-flex justify-content-end cm-news-date">{{item.newsdate}}</p>
                    <p class="cm-news-title">{{item.newstitle}}</p>
                    <p class="cm-news-content" v-html="item.newscontent"></p>
                    <p class="cm-news-link">
                        <a :href="item.newslink" target="_blank">{{item.newslink}}</a>
                    </p>
                </div>
            </div>
        </div>

        <b-col>
            <b-pagination
                align="center"
                :total-rows="totalRows"
                :per-page="perPage"
                v-model="currentPage"
            />
        </b-col>
        
        <b-col
            align="center"
            style="color: #c3c3c3;"
        >{{$t('news.Total')}} {{news.length}} {{$t('news.Records')}}</b-col>
    </div>
</template>

<script>
import $ from 'jquery';
import axios from 'axios';
import store from '@/store/store-controller/store.js'
import eventBus from '@/assets/js/event/EventBus.js'
import CookieUtil from "@/assets/js/util/CookieUtil.js";

var bulletinContent;

export default {
    data() {
        return {
            news: [],
            currentPage: 1,
            totalRows: 1,
            perPage: 5
        };
    },
    mounted() {
        // 更換語言時
        const self = this;
        eventBus.$on(process.env.VUE_APP_EVENT_EMIT_CHANGE_LANGUAGE_ROUTER_NEWS_CONTENT, function(i18n) {
            self.getNews(i18n.locale);
        })
    },
    created() {
        this.getNews(store.getters['storeI18n/getNowLanguage']);
    },
    methods: {
        getNews(language)
        {
            let self = this;
            let lang = language;
            if(lang.includes('en'))
            {
                lang = 'en';
            }

            this.news = [];
            let bodyFormData = new FormData();
            bodyFormData.append("bulletinLanguageCode", lang);
            bodyFormData.append("status", '3');
            bodyFormData.append("bulletinGameCode", 'platform');
            axios({
                method: "post",
                url: process.env.VUE_APP_URL_DOMAIN_LOGIN + "/getBulletinListJsonAction.shtml",
                data: bodyFormData,
                timeout: process.env.VUE_APP_AJAX_TIME_OUT_MILLISECOND,
                config: { headers: {'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8' }}
            })
            .then(function(response) {
                if(response.data.status == "success")
                {
                    bulletinContent = response.data.bulletinContent;
                    for(var obj in bulletinContent)
                    {
                        if(bulletinContent[obj]['bulletinCategory'] == 'news')
                        {
                            let date = (lang == "en" ? new Date(bulletinContent[obj]['startDate']).toDateString() : new Date(bulletinContent[obj]['startDate']).toLocaleDateString())
                            self.news.push({
                                newsimg: bulletinContent[obj]['imageHost'] + bulletinContent[obj]['imagePath'] + bulletinContent[obj]['imageFileName'],
                                newsdate: date,
                                newstitle: bulletinContent[obj]['bulletinTitle'],
                                newscontent: bulletinContent[obj]['bulletinContent'],
                                newslink: ''
                            }); 
                        }
                    }
                        
                    self.currentPage = 1;
                    self.perPage = 5;
                    self.totalRows = self.news.length;
                }
                else
                {
                    self.currentPage = 1;
                    self.perPage = 5;
                    self.totalRows = 0;
                }
                
            })
            .catch(function () {
                alert(self.$i18n.t('common.Backend.Response.ConnectionFailed'));
            });
        }
    },
};
</script>

<style>
.cmv-newscontent .page {
    height: auto;
    color: #c6bdc6;
    text-align: center;
    line-height: 50px;
    font-weight: bold;
    margin: 15px auto;
    overflow: hidden;
}

.cmv-newscontent .page-item.disabled .page-link {
    background: rgba(0, 0, 0, 0);
    border-color: rgba(0, 0, 0, 0);
}
.cmv-newscontent .page-link {
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: #050a0e;
    color: #c6bdc6;
    text-decoration: none;
    background: rgba(0, 0, 0, 0);
    border-color: rgba(0, 0, 0, 0);
}
.cmv-newscontent .page-link:hover {
    color: #fff;
    background-color: #565656;
    text-decoration: none;
    text-align: center;
}
.cmv-newscontent .page-item.active .page-link {
    z-index: 1;
    color: #fff;
    border-color: #007bff;
    background-color: rgba(0, 0, 0, 0) !important;
}
@media screen and (min-width: 1px) {
    .cmv-newscontent .page-item a {
        font-size: 2.4vw;
    }
    .cmv-newscontent .page-link,
    .cmv-newscontent .page-link:hover,
    .cmv-newscontent .page-item.active .page-link {
        height: 5.2vw;
        width: 5.2vw;
        line-height: 2.2vw;
    }
}
@media screen and (min-width: 576px) {
    .cmv-newscontent .page-item a {
        font-size: 1.4vw;
    }
    .cmv-newscontent .page-link,
    .cmv-newscontent .page-link:hover,
    .cmv-newscontent .page-item.active .page-link {
        height: 5.2vw;
        width: 5.2vw;
        line-height: 2.2vw;
    }
}

@media screen and (min-width: 767px) {
    .cmv-newscontent .page-item a {
        font-size: 1.4vw;
    }
    .cmv-newscontent .page-link,
    .cmv-newscontent .page-link:hover,
    .cmv-newscontent .page-item.active .page-link {
        height: 4vw;
        width: 4vw;
        line-height: 2.2vw;
    }
}

@media screen and (min-width: 992px) {
    .cmv-newscontent .page-item a {
        font-size: 1.4vw;
    }
    .cmv-newscontent .page-link,
    .cmv-newscontent .page-link:hover,
    .cmv-newscontent .page-item.active .page-link {
        height: 4vw;
        width: 4vw;
        line-height: 2.2vw;
    }
}

@media screen and (min-width: 1200px) {
    .cmv-newscontent .page-item a {
        font-size: 20px;
    }
    .cmv-newscontent .page-link,
    .cmv-newscontent .page-link:hover,
    .cmv-newscontent .page-item.active .page-link {
        height: 50px;
        width: 50px;
        line-height: 30px;
    }
}
</style>